import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/query_estimated_harvest/show_harvest_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },
  fetchEstimatedHarvests(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/query_estimated_harvest/show_harvest_process/${organization_id}/fetch_estimated_harvests/${harvest_process_id}`
    );
  },
  fetchEstimatedContainers(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/query_estimated_harvest/show_harvest_process/${organization_id}/fetch_estimated_containers/${harvest_process_id}`
    );
  },
  fetchHarvestProcessCropSizeGroups(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/query_estimated_harvest/show_harvest_process/${organization_id}/fetch_harvest_process_crop_size_groups/${harvest_process_id}`
    );
  }
}
